import type { Role } from '@doit/shared';
import {
  Award,
  BarChart3,
  BookOpen,
  CalendarDays,
  ClipboardCheck,
  GraduationCap,
  LayoutDashboard,
  Layers,
  Mail,
  Settings,
  ShieldCheck,
  Upload,
  TriangleAlert,
  UserCog,
  Users,
  type LucideIcon,
} from 'lucide-react';

export type NavItem = {
  to: string;
  label: string;
  icon: LucideIcon;
  roles: Role[];
  /** ჯერ არ არის აწყობილი — მენიუში ჩანს, მაგრამ ნიშნით */
  soon?: boolean;
};

export type NavSection = {
  title: string;
  items: NavItem[];
};

const ALL: Role[] = ['ADMIN', 'MANAGER', 'LECTURER'];
const STAFF: Role[] = ['ADMIN', 'MANAGER'];

export const NAV_SECTIONS: NavSection[] = [
  {
    title: 'მიმოხილვა',
    items: [
      { to: '/', label: 'დეშბორდი', icon: LayoutDashboard, roles: STAFF },
      { to: '/analytics', label: 'ანალიტიკა', icon: BarChart3, roles: STAFF },
      { to: '/flow-results', label: 'ნაკადის შედეგები', icon: Award, roles: STAFF },
    ],
  },
  {
    title: 'სასწავლო პროცესი',
    items: [
      // ლექტორის რიგი: ჯერ ის, რასაც ყოველდღე აკეთებს
      { to: '/journal', label: 'აღრიცხვა', icon: ClipboardCheck, roles: ['LECTURER'] },
      { to: '/groups', label: 'ჯგუფები', icon: Layers, roles: STAFF },
      { to: '/students', label: 'სტუდენტები', icon: GraduationCap, roles: STAFF },
      { to: '/schedule', label: 'განრიგი', icon: CalendarDays, roles: ALL },
      { to: '/journal', label: 'ჟურნალი', icon: ClipboardCheck, roles: STAFF },
      { to: '/groups', label: 'ჯგუფები', icon: Layers, roles: ['LECTURER'] },
      { to: '/attendance', label: 'გაცდენები', icon: TriangleAlert, roles: STAFF },
    ],
  },
  {
    title: 'კატალოგი',
    items: [
      { to: '/catalog', label: 'პროექტები და საგნები', icon: BookOpen, roles: STAFF },
      { to: '/import', label: 'იმპორტი CSV-დან', icon: Upload, roles: STAFF },
    ],
  },
  {
    title: 'ადმინისტრირება',
    items: [
      { to: '/users', label: 'მომხმარებლები', icon: Users, roles: STAFF },
      { to: '/settings', label: 'პარამეტრები', icon: Settings, roles: ['ADMIN'] },
      { to: '/interactions', label: 'ინტერაქცია', icon: Mail, roles: ['ADMIN'] },
      { to: '/audit', label: 'აუდიტი', icon: ShieldCheck, roles: ['ADMIN'] },
      { to: '/profile', label: 'ჩემი პროფილი', icon: UserCog, roles: ALL },
    ],
  },
];

export function navForRole(role: Role): NavSection[] {
  return NAV_SECTIONS.map((section) => ({
    ...section,
    items: section.items.filter((item) => item.roles.includes(role)),
  })).filter((section) => section.items.length > 0);
}
